import { isEmpty } from 'lodash';
import { useSelector } from 'react-redux';
import { Badge, Empty } from 'antd';
import { useTranslation } from 'react-i18next';
import { RoundedIcon } from '../index';
import Icons from '../../../configs/icon.config';
import NotificationList from './NotificationList';
import './index.scss';
import useNotification from '../../../utils/hooks/useNotification';
import { authState } from '../../../app/auth/authSlice';
import Translate from '../Translate';
import { commonState } from '../../../app/base/commonSlice';
import './styles.scss';
import formatBengaliNumber from '../../../utils/banglaNumber';

function DropdownNotification() {
  const { t } = useTranslation();

  const {
    fetchNextPage,
    handleButtonClick,
    hasMore,
    notifications,
    notificationData,
    isLoading,
  } = useNotification();

  const { profile } = useSelector(authState);

  // Using for  tooltip customization
  const { isNotificationExpanded: expanded } = useSelector(commonState);
  // ..

  const { language } = useSelector(commonState);

  const notificationCount =
    typeof notificationData?.results?.unread_count === 'number'
      ? notificationData?.results?.unread_count
      : profile?.user_settings?.unread_notification_count;

  return (
    <div style={{ lineHeight: '24px' }}>
      <button
        disabled={profile?.user_settings?.guided_tour}
        onClick={handleButtonClick}
      >
        <div className="relative">
          {notificationCount > 0 ? (
            <Badge
              offset={[-3, 1]}
              className="notification-badge"
              count={
                // eslint-disable-next-line no-nested-ternary
                language === 'en'
                  ? notificationCount
                  : notificationCount <= 99
                  ? formatBengaliNumber(notificationCount)
                  : `${formatBengaliNumber(99)}+`
              }
              key={notificationCount}
            >
              <RoundedIcon
                iconName={Icons.bell}
                classname="shake-bell notification-button text-pink-600 dark:text-[#EB3E8E]"
                width={35}
                height={35}
                title={`${t('notification.tooltip')}`}
                expanded={expanded}
              />
            </Badge>
          ) : (
            <RoundedIcon
              iconName={Icons.bell}
              classname="notification-button text-pink-600 dark:text-[#EB3E8E]"
              width={35}
              height={35}
              title={`${t('notification.tooltip')}`}
              expanded={expanded}
            />
          )}
        </div>
      </button>
      {expanded && (
        <div className="absolute fade-in z-10 right-[130px] mt-7 w-[400px] bg-white dark:bg-[#181818FF] shadow-lg rounded-lg">
          <p className="flex items-center h-[40px] justify-center font-semibold text-[#212121] dark:text-white p-2 text-[16px] border-b-2 dark:border-[#565657]">
            <Translate en="Notifications" bn="নোটিফিকেশন" />
          </p>
          {!isEmpty(notifications) ? (
            <NotificationList
              hasMore={hasMore}
              data={notifications}
              maxHeight={
                notifications.length > 4 ? 340 : notifications.length * 80 + 10
              }
              fetchNextPage={fetchNextPage}
              isLoading={isLoading}
            />
          ) : (
            <Empty
              className="pb-5 pt-5"
              description={
                <span>
                  <Translate en="No notifications" bn="নোটিফিকেশন নেই" />
                </span>
              }
            />
          )}
        </div>
      )}
    </div>
  );
}

export default DropdownNotification;
